import { profileActionTypes } from "../actions/index";


export const initialState = {
    username: 'username',
    portfolio: 0,
}

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.USER_PORTFOLIO_UPDATE:
            return {
                ...state,
                ...action.payload,
            }
            default:
                return state
    }
}